import { jsx as _jsx } from "react/jsx-runtime";
import { dictionary } from '../../lang';
import { Layout } from '../../layouts';
import AreaPolygonsTable from './AreaPolygonsTable';
/**
 * @TODO: Merge this component with AreaPolygonsTable
 */
const AreaPolygons = () => (_jsx(Layout, { title: dictionary.VIEW_POLYGONS, children: _jsx(AreaPolygonsTable, {}) }));
export default AreaPolygons;
